<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'InputWithObj',
    props: ['form', 'placeholder', 'rules', 'field', 'objkey', 'label', 'maxlength', 'id', 'type', 'dense', 'readonly'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field][this.objkey]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD_OBJ`, { obj: this.field, key: this.objkey, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-text-field
    class="py-0 my-0"
    v-model="model"
    :dense="dense"
    :id="id"
    :maxlength="maxlength || 64"
    :placeholder="placeholder"
    :rules="rules"
    outlined
    :label="label"
    :type ="type || 'text'"
    :readonly="readonly"
  />
</template>

<style lang="scss" scoped>
  .v-input {
    height: 55px;
  }
</style>